import { C } from "../../shared/theme";
import { RESEARCH } from "./learnContent";
import { sectionLabel, pageTitle, intro } from "./learnStyles";

const SOURCE_COUNT = RESEARCH.reduce((n, g) => n + g.items.length, 0);

export function ResearchPage() {
  return (
    <div style={{ padding: "4px 20px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
      <h1 tabIndex={-1} style={{ ...pageTitle, color: C.text, outline: "none" }}>The research</h1>
      <p style={intro()}>Everything in Learn comes from {SOURCE_COUNT} sources: well-known books on habits and getting things done, and the psychology research behind them. Each page in Learn lists its own under "The research behind this".</p>
      {RESEARCH.map(g => (
        <section key={g.label} style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 6 }}>
          <h2 style={{ ...sectionLabel(C.textMid), margin: 0, letterSpacing: "0.06em" }}>{g.label}</h2>
          <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 8 }}>
            {g.items.map(it => <li key={it} style={{ fontSize: 14, lineHeight: 1.5, color: C.textMid, paddingLeft: 12, borderLeft: `2px solid ${C.border}` }}>{it}</li>)}
          </ul>
        </section>
      ))}
    </div>
  );
}
